import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.scss';

export const LanguageSwitcher = () => {
  const { currentLanguage, changeLanguage } = useLanguage();
  const { t } = useTranslation();

  const toggleLanguage = () => {
    const newLanguage = currentLanguage === 'en' ? 'ar' : 'en';
    changeLanguage(newLanguage);
  };

  return (
    <button 
      className="language-switcher" 
      onClick={toggleLanguage}
      aria-label={`Switch to ${currentLanguage === 'en' ? 'Arabic' : 'English'}`}
    >
      <div className="language-toggle">
        <span className={`lang-option ${currentLanguage === 'en' ? 'active' : ''}`}>
          EN
        </span>
        <span className="separator">|</span>
        <span className={`lang-option ${currentLanguage === 'ar' ? 'active' : ''}`}>
          عر
        </span>
      </div>
    </button>
  );
};